import { Grid } from "@material-ui/core";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import Statistic from "./Statistic";
import TokenHealthHistogram from "./TokenHealthHistogram";
import TokenScoreRanking from "./TokenScoreRaking";
import TopTable from "./TopTable";

export default function OverviewTokenHealth() {
  return (
    <>
      <CommonBreadcrumb mb={1} config={[{ text: "scoring" }, { text: "tokens health", link: "/tokens-health" }]} />
      <Grid container spacing={3}>
        <Grid item md={6} xs={12} style={{ marginBottom: 20 }}>
          <Statistic />
        </Grid>
        <Grid item md={6} xs={12}>
          <TokenHealthHistogram />
        </Grid>
        <Grid item xs={12}>
          <TokenScoreRanking />
        </Grid>
        <Grid item xs={12}>
          <TopTable />
        </Grid>
      </Grid>
    </>
  );
}
